var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"mx-auto",attrs:{"id":"app"}},[(!_vm.isLoggedIn)?_c('Welcome'):_vm._e(),(_vm.isLoggedIn)?_c('LoggedInView',{attrs:{"userinfowrapper":_vm.userInfoWrapper}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }